<template>
    <section class="bg-white row q-mx-auto q-py-xl container-global faq-section">
        <div style="width: 100%;">
            <div class="row  questions_container">

                <div class="header_section">
                    <h3 class="header_section-title">
                        الأسئلة الشائعة
                    </h3>
                    <p class="header_section-description fs-md">
                        كل ما تحتاج معرفته قبل أن تبدأ. إذا عندك سؤال، هنا غالبًا
                        تلقى الجواب. وإن ما لقيته، تقدر تتواصل معنا مباشرة. </p>
                </div>
                <div class="">
                    <q-list class="rounded-borders">
                        <q-expansion-item v-for="(item, index) in faqList" :key="index" switch-toggle-side
                            :label="item.question" header-class="list-header" role="listitem">
                            <q-card class="question_answer_card">
                                <q-card-section class="question_answer">
                                    <div v-html="item.answer" class=""></div>
                                </q-card-section>
                            </q-card>
                        </q-expansion-item>
                    </q-list>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
interface FAQItem {
    question: string;
    answer: string;
}

defineProps<{
    faqList: FAQItem[];
}>();
</script>

<style scoped lang="scss">
.questions_container {
    border: 2px solid #eee;
    border-radius: 20px;
    padding: 30px;
    width: 100%;
    margin-inline: auto;
    align-items: start;
    justify-content: space-between;
    flex-wrap: nowrap;
    > div {
        width: 50%;
    }
    @media (max-width: 992px) {
        flex-direction: column;
        align-items: center;
        justify-content: center;
        > div {
            width: 100%;
        }

    }
    @media (max-width: 768px) {
        padding: 20px 16px;
        border-radius: 16px;
        margin: 0;
    }

    @media (max-width: 480px) {
        padding: 16px 4px;
        border-radius: 12px;

    }

    .list-header {
        flex-direction: row-reverse;
        padding-block: 20px;

        @media (max-width: 768px) {
            padding-block: 16px;
        }

        @media (max-width: 480px) {
            padding-block: 12px;
        }
    }
}

.title-question {
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 16px;

    @media (max-width: 768px) {
        font-size: 1.5rem;
        margin-bottom: 12px;
    }

    @media (max-width: 480px) {
        font-size: 1.25rem;
        margin-bottom: 10px;
    }
}

.desc-title-question {
    width: 50%;
    margin-inline: auto;
    margin-top: 30px;
    font-size: 18px;
    color: var(--bs-text-color-secondary);
    line-height: 1.6;

    @media (max-width: 992px) {
        width: 100%;
        margin-top: 20px;
        font-size: 16px;
    }

    @media (max-width: 768px) {
        margin-top: 16px;
        font-size: 15px;
        padding: 0 8px;
    }

    @media (max-width: 480px) {
        margin-top: 12px;
        font-size: 14px;
        padding: 0 4px;
    }
}

.list-header,
.question_answer,
.question_answer_card {
    font-size: var(--fs-sm) !important;
    font-weight: 500 !important;
    color: var(--bs-text-color) !important;
    line-height: 1.2;
}
</style>
<style>
.q-item.q-item-type.row.no-wrap.q-item--clickable.q-link.cursor-pointer.q-focusable.q-hoverable.list-header {
    flex-direction: row-reverse;
}

.faq-section .q-item__label {
    font-size: var(--fs-md) !important;
    font-weight: 500 !important;
    color: var(--bs-text-color) !important;
    line-height: 1.2;
}
</style>